import React, { useState, useCallback } from 'react'
import useRouter from 'utils/useRouter'
import { Grid, MenuItem, withStyles, Menu, ListItemIcon, ListItemText } from '@material-ui/core'
import PhotoIcon from '@material-ui/icons/Photo'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import AddCommentIcon from '@material-ui/icons/AddComment'
import CallMissedOutgoingIcon from '@material-ui/icons/CallMissedOutgoing'
import PersonIcon from '@material-ui/icons/Person'
import EditIcon from '@material-ui/icons/Edit'
import DoneOutlineIcon from '@material-ui/icons/DoneOutline'
import AddIcon from '@material-ui/icons/Add'
import constants from 'utils/constants'
import { useCadaverService } from 'hooks/useCadaverService'
import CallReceivedIcon from '@material-ui/icons/CallReceived'
import CallMadeIcon from '@material-ui/icons/CallMade'
import SupervisedUserCircleIcon from '@material-ui/icons/SupervisedUserCircle'
import { ModalGerenciarAcesso } from 'components/ModalGerenciarAcesso'
import { CustomButton, ModalConfirmacao } from 'components'
import { useAuth } from 'hooks/useAuth'
import { useStyles } from './MenuAcoes.styles'

const StyledMenu = withStyles({
  paper: {
    border: '1px solid #d3d4d5',
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'center',
    }}
    {...props}
  />
))

const StyledMenuItem = withStyles((theme) => ({
  root: {
    '&:focus': {
      backgroundColor: theme.palette.secondary.main,
      '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem)

export const MenuAcoes = (props) => {
  const { cadaver, setCadaver } = props
  const cadaverService = useCadaverService()
  const classes = useStyles()

  const router = useRouter()
  const [anchorEl, setAnchorEl] = useState(null)
  const { currentUser, verificarPermissao } = useAuth()

  const [liberarCadaver, setLiberarCadaver] = useState(false)
  const [processandoLiberarCadaver, setProcessandoLiberarCadaver] = useState(false)
  const [isGerenciarAcessoOpen, setIsGerenciarAcessoOpen] = useState(false)

  const handleBotaoLiberarCadaver = async () => {
    await cadaverService.liberarCadaver(cadaver.id, setCadaver, setProcessandoLiberarCadaver)
    setLiberarCadaver(false)
  }

  const handleClickBotaoAcoes = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleMenuBotaoAcoes = (to) => {
    router.history.push(to)
  }

  const clickOpenLiberarCadaver = () => {
    setLiberarCadaver(true)
    handleClose()
  }

  const fecharModalLiberarCadaver = () => {
    setLiberarCadaver(false)
  }

  const handleClickAdicionarInformacao = useCallback(() => {
    router.history.push(`/cadaver/adicionarInformacao/${cadaver.id}`)
  }, [cadaver.id, router.history])

  return (
    <Grid alignItems="center" justifyContent="flex-end" container spacing={1}>
      <Grid item>
        <CustomButton
          aria-controls="customized-menu"
          aria-haspopup="true"
          onClick={handleClickBotaoAcoes}
          endIcon={<ArrowDropDownIcon />}
          colorType="primary"
        >
          Ações
        </CustomButton>

        <StyledMenu id="customized-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
          <>
            <StyledMenuItem
              onClick={() => handleMenuBotaoAcoes(`/casos/caso/cadaver/editarCadaver/${cadaver.id}`)}
              disabled={!verificarPermissao([constants.PERMISSOES.CADASTRAR_CADAVER])}
            >
              <ListItemIcon>
                <EditIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Editar cadáver" />
            </StyledMenuItem>

            <StyledMenuItem
              onClick={() => handleMenuBotaoAcoes(`/casos/caso/cadaver/extrair/${cadaver.id}`)}
            >
              <ListItemIcon>
                <AddIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Extrair vestígio" />
            </StyledMenuItem>

            <StyledMenuItem
              onClick={() => handleMenuBotaoAcoes(`/casos/caso/cadaver/reconhecimento/${cadaver.id}`)}
              disabled={cadaver.classificacao !== 'NAO_IDENTIFICADO' || !verificarPermissao([constants.PERMISSOES.RECONHECER_CADAVER])}
            >
              <ListItemIcon>
                <PersonIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Reconhecer cadáver" />
            </StyledMenuItem>

            {(cadaver.status === 'PENDENTE' || cadaver.status === 'EXUMADO') && (
              <StyledMenuItem
                onClick={clickOpenLiberarCadaver}
                disabled={!verificarPermissao([constants.PERMISSOES.LIBERAR_CADAVER])}
              >
                <ListItemIcon>
                  <DoneOutlineIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Liberar cadáver" />
              </StyledMenuItem>
            )}

            {!(cadaver.status === 'ENTREGUE') && (
              <StyledMenuItem
                onClick={() => handleMenuBotaoAcoes(`/casos/caso/cadaver/entrega/${cadaver.id}`)}
                disabled={cadaver.status !== 'LIBERADO' || !verificarPermissao([constants.PERMISSOES.ENTREGAR_CADAVER])}
              >
                <ListItemIcon>
                  <CallMissedOutgoingIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Entregar cadáver" />
              </StyledMenuItem>
            )}

            <StyledMenuItem
              onClick={() => handleMenuBotaoAcoes(`/cadaver/inumar/${cadaver.id}`)}
              disabled={cadaver.status !== 'LIBERADO' || !verificarPermissao([constants.PERMISSOES.ENTREGAR_CADAVER])}
            >
              <ListItemIcon>
                <CallReceivedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Inumar cadáver</ListItemText>
            </StyledMenuItem>

            <StyledMenuItem
              onClick={() => handleMenuBotaoAcoes(`/cadaver/exumar/${cadaver.id}`)}
              disabled={!(cadaver.status === 'ENTREGUE' || cadaver.status === 'INUMADO') || !verificarPermissao([constants.PERMISSOES.ENTREGAR_CADAVER])}
            >
              <ListItemIcon>
                <CallMadeIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Exumar cadáver</ListItemText>
            </StyledMenuItem>

            <StyledMenuItem onClick={handleClickAdicionarInformacao}>
              <ListItemIcon>
                <AddCommentIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Adicionar Informação</ListItemText>
            </StyledMenuItem>

            <StyledMenuItem onClick={() => handleMenuBotaoAcoes(`/galeria/cadaver/${cadaver.id}`)}>
              <ListItemIcon>
                <PhotoIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Ver galeria" />
            </StyledMenuItem>

            {currentUser.cargo.id === 1 && (
              <StyledMenuItem onClick={() => { setIsGerenciarAcessoOpen(true); handleClose(); }}>
                <ListItemIcon>
                  <SupervisedUserCircleIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary="Conceder Acesso à galeria" />
              </StyledMenuItem>
            )}
          </>
        </StyledMenu>
      </Grid>

      <ModalGerenciarAcesso open={isGerenciarAcessoOpen} onClose={() => setIsGerenciarAcessoOpen(false)} idCaso={cadaver.id_caso} usuarios={[]} selecionados={[]} />

      <ModalConfirmacao
        aberto={liberarCadaver}
        onClose={fecharModalLiberarCadaver}
        onConfirm={handleBotaoLiberarCadaver}
        processando={processandoLiberarCadaver}
        titulo="Liberar cadáver?"
        confirmarLabel="Confirmar"
        cancelarLabel="Cancelar"
        confirmarColor="secondary"
      >
        O cadáver mudará seu status para LIBERADO. Tem certeza de que deseja realizar esta operação?
      </ModalConfirmacao>
    </Grid>
  )
}
